import React, { useContext } from 'react';
import { ChartContext } from "../../../store/ChartContext";
import { create_checkout_session } from "../../../api/backendApi";
import { BASIC_ID,  PRO_MONTHLY_ID, PRO_YEARLY_ID, EXPERT_MONTHLY_ID, EXPERT_YEARLY_ID } from "../../../env";

export const TechnicalAnalysisContainer = () => {
    const { chatGPTData } = useContext(ChartContext);

    return (
        <>
            {!chatGPTData && (
                <p style={{ textAlign: 'left' }}>Additional information will be displayed here after selecting the chart parameters.</p>
            )}

          {chatGPTData && chatGPTData?.error && (
                <p style={{ color: 'red' }}>Error: {chatGPTData.error}</p>
          )}

          {chatGPTData && chatGPTData?.analysis && (
            <div className="container mx-auto p-4 bg-gray-100 rounded-lg shadow-lg">
              <h1 className="text-2xl font-bold text-gray-800 mb-6">
                Instrument Analysis: {chatGPTData.instrument}
              </h1>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Overview of current trends across different timeframes</h2>
                <table className="min-w-full table-auto border-collapse border border-gray-300 bg-white">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="px-4 py-2 border border-gray-300 text-left">Interval</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Direction</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {chatGPTData.analysis.trends.map((trend, index) => (
                      <tr key={index} className="hover:bg-gray-100">
                        <td className="px-4 py-2 border border-gray-300">{trend.interval}</td>
                        <td className="px-4 py-2 border border-gray-300">{trend.direction}</td>
                        <td className="px-4 py-2 border border-gray-300">{trend.details}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Support zones across different timeframes</h2>
                <table className="min-w-full table-auto border-collapse border border-gray-300 bg-white">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="px-4 py-2 border border-gray-300 text-left">Interval</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Level</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Description</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Significance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {chatGPTData.analysis.supports.map((support, index) => (
                      <tr key={index} className="hover:bg-gray-100">
                        <td className="px-4 py-2 border border-gray-300">{support.interval}</td>
                        <td className="px-4 py-2 border border-gray-300">{support.level}</td>
                        <td className="px-4 py-2 border border-gray-300">{support.description}</td>
                        <td className="px-4 py-2 border border-gray-300">{support.meaning_support_zone}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Resistance zones across different timeframes</h2>
                <table className="min-w-full table-auto border-collapse border border-gray-300 bg-white">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="px-4 py-2 border border-gray-300 text-left">Interval</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Level</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Description</th>
                      <th className="px-4 py-2 border border-gray-300 text-left">Significance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {chatGPTData.analysis.resistances.map((resistance, index) => (
                      <tr key={index} className="hover:bg-gray-100">
                        <td className="px-4 py-2 border border-gray-300">{resistance.interval}</td>
                        <td className="px-4 py-2 border border-gray-300">{resistance.level}</td>
                        <td className="px-4 py-2 border border-gray-300">{resistance.description}</td>
                        <td className="px-4 py-2 border border-gray-300">{resistance.meaning_resistance_zone}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Analysis Summary</h2>
                <p className="text-gray-600">{chatGPTData.analysis.summary_of_the_analysis}</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Recommendation</h2>
                <p className="text-gray-600">{chatGPTData.analysis.recommendation}</p>
              </section>
            </div>

            ) }
        </>
    );
};
